import { usePetitionDetailsPageData, usePetitionDetailsPageUserData } from '#src/app/pages/petitionDetails/pageContext';

import { EmergencyBanner } from './EmergencyBanner';
import { SpikingPetitionBanner } from './SpikingPetitionBanner';
import { StarterDashPromptingBanner } from './StarterDashPromptingBanner';

export const BannerSection: React.FC = () => {
	const {
		data: {
			starterDashboardPromptingBannerEnabled,
			experiments: { spikingPetitionBanner },
		},
	} = usePetitionDetailsPageUserData();
	const {
		data: {
			petition: { emergencyBannerContent: emergencyBanner },
		},
	} = usePetitionDetailsPageData();

	if (emergencyBanner) {
		return <EmergencyBanner emergencyBanner={emergencyBanner} />;
	}

	if (starterDashboardPromptingBannerEnabled) {
		return <StarterDashPromptingBanner />;
	}

	if (spikingPetitionBanner) {
		return (
			<SpikingPetitionBanner experiment={spikingPetitionBanner.experiment} petition={spikingPetitionBanner.petition} />
		);
	}

	return null;
};
